<script setup lang="ts">
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import { useI18n } from 'vue-i18n'
import type { Article } from '@/types/articles'

const { t } = useI18n()

const props = defineProps<{
  articles: Article[]
}>()
</script>

<template>
  <div class="search-articles mt-7 xl:mt-0 xl:pl-6">
    <div class="flex flex-row items-end mb-3">
      <h4 class="text-lg text-primary mb-0">
        {{ t('articles') }}
      </h4>
      <RouterLink
        v-if="false"
        v-close-popper
        to="/"
        class="ml-3 text-primary-700 text-sm"
      >
        <strong class="underline mr-1">{{ t('all_articles') }}</strong>
        <i class="mi-arrow-r icon-12" />
      </RouterLink>
    </div>
    <div class="search-articles-grid grid">
      <article
        v-for="(article, index) in props.articles"
        :key="index"
        class="rounded-lg bg-white shadow p-2 relative"
      >
        <RemoteResponsiveImage
          :product-image-data="article.image"
          img-class="w-100 mb-4"
          :alt="article.title"
          sizes="(min-width: 1200px) 25vw, (min-width: 992px) 20vw, (min-width: 600px) 35vw, (min-width: 500px) 50vw, 70vw"
        />
        <div class="text-muffled text-xs mb-2">
          <strong
            v-for="(item, itemIndex) in article.tags"
            :key="itemIndex"
          >
            {{ item.name }}
            <span
              v-if="itemIndex < article.tags.length - 1"
              class="mx-1"
            >•</span>
          </strong>
        </div>
        <h2 class="mb-4 leading-base text-sm font-family-base">
          <router-link
            v-close-popper
            :to="{ name: 'showBlogPath', params: { permalink: article.permalink } }"
            class="stretched-link no-decoration"
          >
            {{ article.title }}
          </router-link>
        </h2>
      </article>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-articles {
  flex: 1;

  .search-articles-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }
}
</style>

<i18n>
  {
    "cs": {
    "all_articles": "Všechny články",
    "articles": "Články"
},
    "sk": {
    "all_articles": "Všetky články",
    "articles": "Články"
},
    "pl": {
    "all_articles": "Wszystkie artykuły",
    "articles": "Artykuły"
},
    "hu": {
    "all_articles": "Minden cikk",
    "articles": "Cikkek"
},
    "de": {
    "all_articles": "Alle Artikel",
    "articles": "Artikel"
},
    "at": {
    "all_articles": "Alle Artikel",
    "articles": "Artikel"
},
    "ro": {
    "all_articles": "Toate articolele",
    "articles": "Articole"
}
  }
</i18n>